var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0658,
    cy: 17.0658,
    r: 6.62436,
    stroke: "#011133",
    strokeWidth: 1.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7109,
    y: 6,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(19.2106 20.7109 6)",
    fill: "#011133"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.252,
    y: 24.1797,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(20.7117 13.252 24.1797)",
    fill: "#011133"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9199,
    y: 6.58594,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-25.7894 11.9199 6.58594)",
    fill: "#011133"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5039,
    y: 24.7109,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-24.2883 19.5039 24.7109)",
    fill: "#011133"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13.332,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-70.7894 6 13.332)",
    fill: "#011133"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1797,
    y: 21.4023,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-69.2883 24.1797 21.4023)",
    fill: "#011133"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.58984,
    y: 22.8203,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-115.789 6.58984 22.8203)",
    fill: "#011133"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9297,
    y: 15.0586,
    width: 1.34673,
    height: 3.36681,
    rx: 0.673363,
    transform: "rotate(-114.288 24.9297 15.0586)",
    fill: "#011133"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5436 19.5434L14.3263 14.3261",
    stroke: "#011133",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6757 14.3261L14.4583 19.5434",
    stroke: "#011133",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLight);
export default __webpack_public_path__ + "static/media/No-light.4cec29020d32f317584fe3b8a6517cc4.svg";
export { ForwardRef as ReactComponent };